export default __webpack_public_path__ + "static/media/nickson.a93bf045.jpg";